<template>
  <div>
    <Jumbotron title="F.A.Q." />

    <b-container class="p-3">
      <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" content-class="mt-3" fill>
        <b-tab title="General" active>
          <b-card no-body class="mb-2">
            <b-card-header v-b-toggle.general-accordion-0 header-tag="header" class="p-3 cursor-pointer">
              <b>Apa yang membedakan layanan tersebut ?</b>
            </b-card-header>
            <b-collapse id="general-accordion-0" accordion="general-faq-accordion">
              <b-card-body>
                <b-card-text>
                  <ul>
                    <li v-for="(product, index) in product_list" :key="index">
                      {{ product }}
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-2" v-for="general in general_faq" :key="general.no">
            <b-card-header v-b-toggle="'general-accordion-' + general.no" header-tag="header" class="p-3 cursor-pointer">
              <b>{{ general.q }}</b>
            </b-card-header>
            <b-collapse :id="'general-accordion-' + general.no" accordion="general-faq-accordion">
              <b-card-body>
                <b-card-text>
                  {{ general.a }}
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-tab>

        <b-tab title="Consultation">
          <b-card no-body class="mb-2" v-for="consultation in consultation_faq" :key="consultation.no">
            <b-card-header v-b-toggle="'consultation-accordion-' + consultation.no" header-tag="header" class="p-3 cursor-pointer">
              <b>{{ consultation.q }}</b>
            </b-card-header>
            <b-collapse :id="'consultation-accordion-' + consultation.no" accordion="consultation-faq-accordion">
              <b-card-body>
                <b-card-text>
                  {{ consultation.a }}
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-tab>

        <b-tab title="Easy Reschedule">
          <b-card no-body class="mb-2" v-for="easy_reschedule in easy_reschedule_faq" :key="easy_reschedule.no">
            <b-card-header v-b-toggle="'easy-reschedule-accordion-' + easy_reschedule.no" header-tag="header" class="p-3 cursor-pointer">
              <b>{{ easy_reschedule.q }}</b>
            </b-card-header>
            <b-collapse :id="'easy-reschedule-accordion-' + easy_reschedule.no" accordion="easy-reschedule-faq-accordion">
              <b-card-body>
                <b-card-text>
                  {{ easy_reschedule.a }}
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-tab>

        <b-tab title="Event Alert">
          <b-card no-body class="mb-2" v-for="event_alert in event_alert_faq" :key="event_alert.no">
            <b-card-header v-b-toggle="'event-alert-accordion-' + event_alert.no" header-tag="header" class="p-3 cursor-pointer">
              <b>{{ event_alert.q }}</b>
            </b-card-header>
            <b-collapse :id="'event-alert-accordion-' + event_alert.no" accordion="event-alert-faq-accordion">
              <b-card-body>
                <b-card-text>
                  {{ event_alert.a }}
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-container>

    <b-container class="mt-5" />
  </div>
</template>

<script>
import Jumbotron from '@/components/Jumbotron'

export default {
  name: 'FAQ',
  components: {
    'Jumbotron': Jumbotron
  },
  data () {
    return {
      general_faq: [
        {
          no: '1',
          q: 'Apakah  STARGUIDES ?',
          a: 'Sebuah perusahaan jasa traveling untuk membantu para traveller.'
        },
        {
          no: '2',
          q: 'Apakah saya bisa memakai layanan STARGUIDES ?',
          a: 'Ya, kami akan memberikan layanan jasa guide terbaik untuk memberikan kepuasan pelanggan.'
        },
        {
          no: '3',
          q: 'Apa layanan yang akan di tawarkan STARGUIDES ?',
          a: 'Kami akan memberikan beberapa pilihan layanan kepada seluruh member STARGUIDES.'
        },
        {
          no: '4',
          q: 'Layanan seperti apa yang akan di tawarkan STARGUIDES ?',
          a: 'Kami memberikan 6 layanan untuk seluruh member STARGUIDES : STARX, STARVAN, STARGROUP, STARTRIP, STARPICK & STARROAD.'
        },
        /* {
          no: '5',
          q: 'Apa yang membedakan layanan tersebut ?',
          a: ''
        }, */
        {
          no: '6',
          q: 'Apakah para Gudiers bisa berbahasa Indonesia ?',
          a: 'Ya, kami memberikan Guiders mahasiswa atau pun orang Indonesia yang tinggal di luar negri.'
        },
        {
          no: '7',
          q: 'Apakah guiders mengerti Bahasa di daerah tersebut ?',
          a: 'Ya, Kami mewajibkan untuk menjadi Guiders kami untuk berbahasa local.'
        },
        {
          no: '8',
          q: 'Bagaimana jika saya terjadi kehilangan passpor ?',
          a: 'Guiders kami akan membantu untuk mengurus laporan di kepolisian setempat dan membantu untuk mengurus SPLP (Surat Perjalanan Laksana Passpor) di KBRI di negara anda berada, dan dengan identitas member STARGUIDES yang anda masukan ke dalam sistem kami.'
        },
        {
          no: '9',
          q: 'Bagaimana saya bisa mendapatkan layanan tersebut ?',
          a: 'Untuk saat ini cukup anda isi di formulir order kami, maka kami akan menghubungi anda secepatnya.'
        },
        {
          no: '10',
          q: 'Bagaimana cara pembayarannya ?',
          a: 'Untuk saat ini sistem kami masih dalam proses untuk melakukan pembayaran otomatis, jadi kami hanya melakukan transfer ke bank perusahaan.'
        }
      ],
      consultation_faq: [
        {
          no: '1',
          q: 'Apakah Consultation ?',
          a: 'Jasa konsultasi itinerary di tempat tertentu untuk semua member STARGUIDES.'
        },
        {
          no: '2',
          q: 'Apakah saya bisa memakai layanan Consultation ?',
          a: 'Ya, kami akan memberikan layanan Consultation untuk semua member STARGUIDE jika memiliki id member.'
        },
        {
          no: '3',
          q: 'Berapa biaya layanan Consultation ?',
          a: 'Untuk layanan Consultation akan kami berikan GRATIS kepada member STARGUIDE jika sudah melakukan pembayaran.'
        },
        {
          no: '4',
          q: 'Bagaimana saya bisa mendapatkan layanan tersebut ?',
          a: 'Anda dapat menghubungi tim kami terlebih dahulu untuk melakukan appointment.'
        }
      ],
      easy_reschedule_faq: [
        {
          no: '1',
          q: 'Dapatkah saya mengganti jadwal saya melalui Easy Reschedule ?',
          a: 'Ya, anda dapat mengganti jadwal sesuai keinginan anda. Silahkan baca Terms & Condition sebelum anda melakukan reservasi.'
        },
        {
          no: '2',
          q: 'Dapatkah saya mengganti jumlah kapasitas orang dan rute yang akan saya datangi ?',
          a: 'Ya, Anda dapat mengganti jadwal dan jumlah kapasitas orang sesuai dengan layanan dan kapasitas yang sudah ditentukan. Silahkan baca Terms & Condition sebelum anda melakukan reservasi.'
        },
        {
          no: '3',
          q: 'Dapatkah saya mengganti nama atau detail costumers ?',
          a: 'Ya, Anda dapat mengganti nama atau detail lainnya sesuai keinginan anda. Tapi baca Terms & Condition sebelum anda melakukan reservasi.'
        },
        {
          no: '4',
          q: 'Dapatkah saya menggunakan Easy Reschedule kapan saja ?',
          a: 'Ya, anda dapat menggunakan kapan saja dan dimana anda berada.'
        },
        {
          no: '5',
          q: 'Apakah harga yang ditampilkan adalah harga total ?',
          a: 'Ya, harga yang ditampilkan adalah harga yang harus anda bayar untuk kompensasi para Guiders.'
        },
        {
          no: '6',
          q: 'Kapankah saya dapat tanda terima ?',
          a: 'Anda akan mendapatkan tanda terima dalam 30 menit setelah pembayaran kompensasi.'
        },
        {
          no: '7',
          q: 'Berapa lama saya akan mendapatkan kembali pembayaran saya ?',
          a: 'Pembayaran anda akan kembali dalam waktu 7-14 hari kerja.'
        },
        {
          no: '8',
          q: 'Pembayaran apa saja yang dapat di terima dari Easy Reschedule ?',
          a: 'Untuk saat ini layanan kami hanya dapat menyediakan pembayaran melalui Credit Card.'
        },
        {
          no: '9',
          q: 'Apakah Easy Reschedule tersedia dalam semua platform STARGUIDE ?',
          a: 'Ya, Easy Reschedule dapat anda lakukan di website STARGUIDE dan Applikasi (Soon).'
        }
      ],
      event_alert_faq: [
        {
          no: '1',
          q: 'SMART TRACKING',
          a: 'Peringatan Acara berfungsi sebagai alat pemantauan Acara, yang melacak acara besar dan tren yang sedang terjadi di setiap negara yang anda inginkan langsung ke kotak masuk anda.'
        },
        {
          no: '2',
          q: 'FLEXIBLE DATE OPTION',
          a: 'Belum menentukan tanggal pasti ? Tidak masalah. Anda dapat membuat tanggal sesuai keinginan anda.'
        },
        {
          no: '3',
          q: 'INSTANT NOTOFICATION',
          a: 'Anda akan dapat peringatan secepat mungkin bila ada event besar yang akan terjadi di negara yang akan anda kunjungi, sehingga anda dapat menentukan perjalanan yang akan anda kunjungi.'
        },
        {
          no: '4',
          q: 'EASY TO SET UP',
          a: 'Anda hanya perlu mengisi rincian jadwal yang anda inginkan, seperti tanggal yang anda butuhkan, jumlah peserta, data passport setiap orang, dan anda akan siap.'
        }
      ],
      product_list: [
        'STARX: Cocok untuk anda yang memiliki keluarga, teman, atau sahabat dekat yang ingin bepergian dengan kapasitas 1 – 4 orang hanya dalam 1 kota dengan waktu minimum 8 jam perhari.',
        'STARVAN: Cocok untuk anda yang memiliki keluarga besar, teman-teman, group kantor atau seluruh teman terbaik yang ingin bepergian dengan kapasitas 5 – 8 orang hanya dalam 1 kota dengan waktu minimum 8 jam perhari.',
        'STARGROUP: Cocok untuk anda yang memiliki keluarga sangat besar, teman kuliah, teman kantor atau seluruh anggota organisasi yang ingin bepergian dengan kapasitas 8 – 13 orang hanya dalam 1 kota dengan waktu minimum 8 jam perhari.',
        'STARTRIP: Cocok untuk anda yang ingin bepergian keliling ke beberapa negara lain dan di temani Guiders terbaik kami, dengan kapasitas 1 – 8 orang dengan waktu minimum 10 jam perhari.',
        'STARROAD: Cocok untuk anda yang memiliki hobi ROAD TRIP, dan berkeliling sesuka hati anda dengan di temani Guiders terbaik yang mempunyai pengalaman mengemudi, dan berkapasitas 1 – 8 orang dengan waktu minimum 10 jam perhari.',
        'STARPICK: Sangat cocok untuk anda belum mengerti daerah dan hanya ingin di antarkan dari Bandara/Station ke Hotel, atau dari Hotel ke Bandara/Station.'
      ],
      guarantee_list: [
        'Berlaku hanya dari pembelian platform STARGUIDES.',
        'Berlaku untuk semua Member (Guiders & User) yang terdaftar dari STARGUIDES.',
        'Jika anda merasa lama untuk mendapatkan Guiders silahkan hubungi tim kami agar dapat membantu anda.',
        'Anda berhak melakukan Report jika ada terjadi kecurangan.',
        'Jika terjadi kecurangan, sistem/admin kami akan memberikan pilihan Guiders lain pada anda.',
        'Jika terjadi kecurangan pada Guiders, kami tidak menarik biaya modifikasi dari anda.',
        'Jika Guiders sudah memulai “Start” sebelum kedatangan anda, maka anda berhak mendapatkan jam sesuai pada ketentuan yang disepakati.',
        'Jika terjadi kehilangan barang/passport, kami akan membantu proses untuk membuatkan laporan kepada polisi di negara yang anda kunjungi dan akan membantu membuat SPLP (Surat Perjalanan Laksana Passpor) di Kedutaan Besar Republik Indonesia jika terjadi kehilangan barang atau passport anda.',
        'Kami akan memproses laporan dan pembuatan SPLP berdasarkan nama atau data passpor yang telah dicantumkan di STARGUIDES.',
        'Jika anda merasa kurang dalam pelayanan para Guiders, anda berhak mengganti guiders di saat masa perjalanan anda.',
        'Jika sistem tidak menemukan Guiders pengganti sesuai keinginan anda, maka kami akan memberikan guiders yang telah anda pilih sebelumnya.'
      ]
    }
  }
}
</script>

<style scoped>
  .card-body {
    background-color: #233c7c;
    color: white;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Static/FAQ.vue